<template>
    <div>
      <Head title="Admin" />
      <v-container class="grey lighten-5">
        <v-card>
          <v-card-title>
            Downloads
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              @input="getDataFromApi()"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            
            <v-spacer></v-spacer>
            <v-btn
            class="mx-2"
            fab
            dark
            color="primary"
            @click="addNew"
          >
            <v-icon dark>
              mdi-plus
            </v-icon>
          </v-btn>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="list"
            :options.sync="options"
            :items-per-page="itemsPerPage"
            :server-items-length="total"
            :loading="loading"
            class="elevation-1"
          >
          <template v-slot:item.actions="{ item }">
            <v-icon
              small
              class="mr-2"
              @click="edit(item.id)"
            >
              mdi-pencil
            </v-icon>
            <a 
                :href="baseurl + '/downloadables/'+item.path" target="_blank">
              <v-icon
                small
                class="mr-2"
                
              >
                mdi-download
              </v-icon>
            </a>
            
          </template>
          <template v-slot:item.active="{ item }">
                <v-icon v-if="item.active == 1" color="success">mdi-check</v-icon>
                <v-icon v-if="item.active == 0" color="error">mdi-close-circle-outline</v-icon>
            </template> 
          <template v-slot:item.event="{ item }">
            <a v-if="item.event"
                :href="baseurl+'/event/'+item.event.alias" target="_blank">
              <v-icon
                small
                class="mr-2"
                
              >
                mdi-eye
              </v-icon>
            </a>
            
          </template>
        </v-data-table>
        </v-card> 

        <v-dialog v-model="dialogAdd"  fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="dialogAdd = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title v-if="dialogType == 'add'">Add New Downloadable</v-toolbar-title>
          <v-toolbar-title v-if="dialogType == 'edit'">Edit {{newdownloadable.name}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
                v-if="dialogType=='add'"
              dark
              text
              @click="saveAddDialog"
            >
              Add
            </v-btn>
            <v-btn
                v-if="dialogType=='edit'"
              dark
              text
              @click="saveEditDialog"
            >
              Update
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
              <v-container v-if="errors">
                <v-row>
                  <v-col cols="12" md="12">
                    <v-alert type="error">
                      <ul>
                        <li v-for="e in errors">
                          {{ e[0] }}
                        </li>
                      </ul>
                      
                    </v-alert>
                  </v-col>
                </v-row>
              </v-container>
              <v-container>
                <v-row>
                    
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <v-select 
                        v-model="newdownloadable.type"
                        label="Download Type"
                        :items="['Public','Event']"
                    >
                    </v-select>
                    <v-select
                        v-show="newdownloadable.type == 'Event'"
                      v-model="newdownloadable.event_id"
                      label="Event"
                      :items="events"
                      item-text="title"
                      item-value="id"
                    ></v-select>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="4"
                  >
                        <v-switch
                        v-model="newdownloadable.active"
                        label="Active"
                        ></v-switch>
                    </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-img :src="newdownloadable.download_path" height="40" width="40">
                    </v-img>
                    <v-file-input
                        accept="audio*,.pdf,video/*"
                      v-model="newdownloadable.download"
                      label="Audio/Video/Pdf"
                      prepend-icon="mdi-file"
                      clearable
                      
                    ></v-file-input>
                  </v-col>
                  
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newdownloadable.name"
                      label="Name"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newdownloadable.alias"
                      label="Alias"
                      hint="No spaces or special characters, e.g. my-downloadable"
                      required
                    ></v-text-field>
                  </v-col>
                 
                  
                </v-row>
                <hr/>
                
                <hr/>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <span class="text-h6">Description</span>
                    <vue-editor
                      v-model="newdownloadable.description"
                      label="Description"
                    ></vue-editor>
                </v-col>
                  
                </v-row>
              </v-container>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="closeAddDialog"
              >
                Cancel
              </v-btn>
              <v-btn
                v-if="dialogType == 'add'"
                color="blue darken-1"
                text
                @click="saveAddDialog"
              >
                Add New
              </v-btn>
              <v-btn
                v-if="dialogType == 'edit'"
                color="blue darken-1"
                text
                @click="saveEditDialog"
              >
                Update
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" >
          <v-card>
            <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialogDelete = !dialogDelete">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-container>
    </div>
  </template>
  
  <script>
  import { Head } from '@inertiajs/inertia-vue'
  import Layout from '@/Shared/VuetifyAdminLayout'
  import axios from 'axios'
  
  import { VueEditor } from "vue2-editor";
  const passwordLength = 12
  const passwordChars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'

  export default {
    props: {
      downloadables: Array,
      events:Array,
      regions:Array,
      baseurl:String,
    },
    components: {
      Head,
      VueEditor
    },
    layout: Layout,
    data() {
        return {
            list: [],
            keyword: "",
            location: "",
            category: "",
            total: this.downloadables.length,
            itemsPerPage: 20,
            loading: false,
            loadingAdd: false,
            options: {},
            errors: false,
            search: "",
            headers: [
              { text: 'ID', value:'id'},
              { text: 'Name', value:'name'},
              { text: 'Event', value:'event'},
              { text: 'Active', value:'active'},
              { text: 'Actions', value:'actions'}

            ],
            newdownloadable: {
              name:"",//
              
              alias: "",//
                active: false,
                type: 'Public',
              description: "",//
              event_id: null,
              download: [],
            },
            dialogType:'add',
            dialogAdd: false,
            dialogDelete: false
        }
    },
    watch: {
      options: {
        handler () {
          this.getDataFromApi()
        },
        deep: true,
      },
    },
    created() {
      this.list = JSON.parse(JSON.stringify(this.downloadables));
    },
    methods: {
      
      edit(id) {
        console.log('attempting to edit id ',id)
        axios.get("/admin/downloads/get/"+id).then((response) => {
            console.log('edit got response',response.data)
            if (response && response.data)
            {
                this.newdownloadable = response.data
                this.dialogAdd = true;
                this.dialogType='edit';
            }
        });
      },
      addNew(){
        this.dialogType='add';
        Object.keys(this.newdownloadable).forEach(key => {
            if (key == 'download')
                this.newdownloadable.key = []
            else
                this.newdownloadable[key] = "";
        });
        this.dialogAdd = true;
      },
      getDataFromApi () {
        this.loading = true
        console.log('getting request',this.options)
        var params = JSON.parse(JSON.stringify(this.options));
        params.filters = { search: this.search, role: this.role };

        axios.get("/admin/downloads/list",{ params: params }).then((response) => {
            console.log('got list',response.data.list)
          this.list = response.data.list
          this.total= response.data.total;
          this.loading = false;
        });
      },
      deleteItemConfirm () {
        this.closeDelete()
      },

      closeAddDialog () {
        this.dialogAdd = false
      },

      closeDelete () {
        this.dialogDelete = false
        
      },
      saveEditDialog () {
        this.loadingAdd=true;
        this.errors = false
        const formData = new FormData()
        Object.keys(this.newdownloadable).forEach(key => formData.append(key, this.newdownloadable[key]));
        axios.post("/admin/downloads/update",formData).then((response) => {
          if (response.status == '200' && response.data == true)
          {
            this.dialogAdd = false;
            this.getDataFromApi();
          }
          else
            alert('Edit failed');
          
            console.log('edit response',response)
            this.loadingAdd = false;
        }).catch(error => {
            console.log('error on edit',error,error.response)
            this.errors = error.response && error.response.data && error.response.data.errors ? Object.values(error.response.data.errors) : []
            this.loadingAdd = false;
          });
        //this.dialogAdd = false
      },
      saveAddDialog () {
        this.loadingAdd=true;
        this.errors = false
        console.log('adding downloadable',this.newdownloadable)
        const formData = new FormData()
        Object.keys(this.newdownloadable).forEach(key => formData.append(key, this.newdownloadable[key]));

        axios.post("/admin/downloads/add",formData).then((response) => {
          console.log('add response',response)
          if (response.status == '200' && response.data == true)
          {
            this.dialogAdd = false;
            this.getDataFromApi();
          }
          else
            alert('Add failed');
          
            console.log('add response',response)
          this.loadingAdd = false;
        })
        .catch(error => {
            console.log('error on add',error,error.response)
            this.errors = error.response && error.response.data && error.response.data.errors ? Object.values(error.response.data.errors) : []
            this.loadingAdd = false;
          });
        //this.dialogAdd = false
      },
      
    },
  }
  </script>
  